var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ucp-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.data,"border":""}},_vm._l((_vm.col),function(item,index){return _c('ucp-table-col',{key:index,attrs:{"col":item}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62761f34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/ucp-table.vue
// module id = 0yx6
// module chunks = 0